import React from 'react';

export default function GroupSelector({ round, onGroupSelect }) {
  // Get unique group numbers from players
  const groups = [...new Set(round.players.map(p => p.group_number))].sort((a, b) => a - b);

  // Get players by group for display
  const getGroupPlayers = (groupNum) => {
    return round.players.filter(p => p.group_number === groupNum);
  };

  return (
    <div>
      {/* Header */}
      <div className="bg-white border-b border-gray-300 px-4 py-3 mb-4">
        <h2 className="text-lg font-semibold text-gray-900 text-center">
          Select Your Group
        </h2>
      </div>

      {/* Instructions */}
      <div className="text-center text-sm text-gray-600 mb-4 px-4">
        <p>Choose your group to start entering scores</p>
      </div>

      <div className="grid grid-cols-1 gap-3 px-4">
        {groups.map((groupNum) => {
          const groupPlayers = getGroupPlayers(groupNum);

          return (
            <button
              key={groupNum}
              onClick={() => onGroupSelect(groupNum)}
              className="min-h-touch-lg p-4 bg-white border-2 border-gray-300 hover:border-primary hover:bg-gray-50 text-left transition-all"
            >
              <div className="flex items-center justify-between mb-2">
                <h3 className="text-lg font-semibold text-gray-900">
                  Group {groupNum}
                </h3>
                <span className="text-sm text-gray-600 bg-gray-100 px-3 py-1 rounded">
                  {groupPlayers.length} players
                </span>
              </div>

              <div className="flex flex-wrap gap-2">
                {groupPlayers.map((player) => (
                  <div
                    key={player.round_player_id}
                    className="text-sm text-gray-700 bg-gray-50 px-3 py-1 rounded border border-gray-200"
                  >
                    {player.player_name}
                  </div>
                ))}
              </div>
            </button>
          );
        })}
      </div>

      <div className="mt-4 text-center text-xs text-gray-500 px-4">
        Your selection will be saved for this round
      </div>
    </div>
  );
}
